const TEST_ID_FIELD_PREFIX = 'field'
const TEST_ID_OPTION_INFIX = 'option'

// Normalise any identifier (camelCase, dotted form paths, UUIDs) into a stable
// kebab token so the same field always yields the same test id across renders.
export const toTestIdToken = (value: string): string =>
  value
    .replace(/([a-z0-9])([A-Z])/g, '$1-$2')
    .replace(/[^a-zA-Z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .toLowerCase()

export const buildFieldTestId = (name?: string | null): string | undefined =>
  name ? `${TEST_ID_FIELD_PREFIX}-${toTestIdToken(name)}` : undefined

export const buildOptionTestId = (
  base: string | undefined,
  value: string | number
): string | undefined =>
  base ? `${base}-${TEST_ID_OPTION_INFIX}-${toTestIdToken(String(value))}` : undefined

// Suffixes a static button/row id with the record it belongs to, so the same control
// repeated once per row stays individually addressable. Falls back to the bare base
// when the record has no id yet, which keeps the id stable rather than index-derived.
export const buildRowTestId = (base: string, recordId?: string | number | null): string =>
  recordId === undefined || recordId === null || recordId === ''
    ? base
    : `${base}-${toTestIdToken(String(recordId))}`

// Explicit `data-testid` always wins over the derived one.
export const resolveFieldTestId = (
  explicitTestId: string | undefined,
  name?: string | null
): string | undefined => explicitTestId ?? buildFieldTestId(name)
